import initializeForm from './initializeForm';
import toggleModal from './openModal';
import resetForm from './resetForm';
import setIsNewRecord from './setIsNewRecord';

export default (values) => (dispatch) => {
    const newValues = {
        id: values.id,
        language: values.language,
        title: values.title,
        type: values.type,
        system: values.system_value,
    };
    dispatch(resetForm());
    dispatch(initializeForm(newValues));
    dispatch(setIsNewRecord(false));
    dispatch(toggleModal(true));
};
